export default __webpack_public_path__ + "static/xeno-process-01-1f8b9291751c0315069a2d50f8ddbe1e.png";